import { Routes } from '@angular/router'

import {
    AdminLayoutComponent,
    Error403Component,
    Error4Component,
    Error5Component,
    GuardService,
    HandbookComponent,
    HandbookTypesResolver,
    LabelResolver,
    SettingsRouteGuard
} from '@surgetech-eu/core'
import { getRoleRoutes } from './app.roles'
import { ComponentTypeResolver } from './eyedes/handbook/component-type/component-type.resolver'
import { environment } from '../environments/environment'

export const AppRoutes: Routes = [
    {
        path: 'settings',
        component: AdminLayoutComponent,
        children: [
            {
                path: 'libraries',
                component: HandbookComponent,
                resolve: {
                    types: HandbookTypesResolver,
                    labels: LabelResolver,
                    unitOfMeasure: ComponentTypeResolver
                },
                data: {
                    labelContexts: [
                        'libraries.supplierTypeTable',
                        'libraries.supplierTable',
                        'libraries.mainPartTable',
                        'libraries.componentTypeTable',
                        'libraries.catalogObjectTypeTable',
                        'libraries.baseMaterialTable',
                        'libraries.baseMaterialCertificationTypeTable',
                        'libraries.materialFamilyTable'
                    ]
                },
                canActivate: [SettingsRouteGuard]
            }
        ],
        canActivate: [GuardService]
    },
    // tslint:disable-next-line:no-string-literal
    ...getRoleRoutes(window['__env']?.types || environment.types),
    {
        path: 'error/404',
        component: Error4Component
    },
    {
        path: 'error/500',
        component: Error5Component
    },
    {
        path: 'error/403',
        component: Error403Component
    },
    {
        path: '**',
        redirectTo: 'error/404'
    }
]
